export default __webpack_public_path__ + "static/media/awo.712f3af9.png";